<template>
    <div class="d-flex flex-row justify-content-center align-items-end page-footer">
        <p class="page-footer-txt">
          <div>
            &copy; 2023 Ascentra Credit Union. | 
            All Rights Reserved | 
            Federally Insured by NCUA | 
            Equal Housing Opportunity
          </div>
        </p>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: 'PageFooter',  
  props: {
    footerText: String,
  },
  computed: {
    ...mapState({
      defaultFooterText: state => state.footerText,            
    }),
    displayText() {
      if(this.footerText) {
        return this.footerText;
      } else {
        return this.defaultFooterText;
      }
    },
  },
}
</script>